<div *ngIf="lottoItem; else noPurchase">
  <div class="d-block d-lg-flex border-0 rounded overflow-hidden mt-lg-4 mt-1 justify-content-center align-items-center">
    <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 p-3">
      <div class="d-lg-flex d-block">
        <div>
          <div class="text-success mb-0 font-praktika-normal font-size-18 text-start mb-1">
            {{ 'lotto.entry.successful' | translate }}
          </div>
          <p class="mb-0 text-black font-size-14 pe-lg-4 lotto-success-description font-praktika-normal">
            <ng-container>{{ 'lottos.purchase.confirm' | translate }}</ng-container>
          </p>
          <div class="d-flex border-0 mt-4">
            <a class="btn btn-primary confirm-btn fw-bold text-white" [routerLink]="['/rewards/wallet']">{{
              'rewards.back.to.wallet' | translate
            }}</a>
          </div>
        </div>
        <div class="border rounded payment-details card">
          <div class="d-lg-flex d-block">
            <div class="me-4">
              <img
                class="purchase-success-image rounded"
                src="{{ lottoItem.ImageName | contentImage: '6' : 'lotto' }}"
                alt="{{ lottoItem.ImageName }}"
                [useDefault]="true"
                [loyaltyTyps]="'lotto'"
                draggable="false"
              />
            </div>
            <div class="my-lg-0 my-3">
              <!--Name-->
              <div class="mb-3 font-praktika-bold font-size-14">{{ lottoItem.Title }}</div>
              <!--Quantity-->
              <div class="d-flex align-items-center mt-2">
                <span class="font-size-12 lotto-details-spacing font-praktika-normal">{{ 'lotto.entries' | translate }}</span>
                <span class="font-praktika-bold font-size-14 ps-2">{{ quantity | number }}</span>
              </div>

              <!--Price-->
              <div class="d-flex align-items-center mt-2">
                <span class="font-size-12 lotto-details-spacing font-praktika-normal">{{ 'lotto.points.used' | translate }}</span>
                <span class="font-praktika-bold font-size-14 ps-2">{{ totalPrice | number }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noPurchase>
  <div class="text-center m-5">No raffles found...</div>
</ng-template>
